import { useState } from 'react'
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import Button from '../../../../common/Button'
import RemoveDataConfirmationModal from '../../../../common/RemoveDataConfirmationModal'
import { removeRelatedPatient } from '../../../../../lib/fetchApi'
import { notificationActions } from '../../../../../store/notifications'
import { caseActions } from '../../../../../store/case'

import classes from './RelatedPatientItem.module.css'
import PatientOrChart from '../../../page/PatientOrChart'
import { formatPatientName } from '../../../../../lib/patientName'

const RelatedPatientItem = ({data, permission, readOnly}) => {
    const dispatch = useDispatch()
    const [removeLoading, setRemoveLoading] = useState(false)
    const [showConfirm, setShowConfirm] = useState(false)

    const userToken = useSelector(state => state.user.token)
    const activeCase = useSelector(state => state.case.activeCase) 

    const removePatientHandler = async () => {
        setShowConfirm(false)
        setRemoveLoading(true)

        let reqBody = {
            related_patients: [data?.id]
        }        

        let update = await removeRelatedPatient(userToken, activeCase.case.id, reqBody)

        if (update && update.errorMessage) {
            dispatch(notificationActions.setError(update))            
        } else {
            let dispatchBody = {
                folder: 'related_patients',
                itemId: data?.id
            }
            dispatch(caseActions.removeFromArray(dispatchBody))
        }  

        setRemoveLoading(false)
    }

    return <div className={classes.item}>
        <div className="flex-container">
            <PatientOrChart item={{case: data}}/>
            <Link to={`../${data?.person_number}`} >
                <span className={classes.name}>{formatPatientName(data, { order: 'lastFirst' })}</span>            
            </Link>
        </div>
        <div className='flex-container'>
            <span className={classes.case}>NG{data?.person_number}</span>
            {permission && !readOnly && (
                <div style={{ position: 'relative' }}>
                    <Button title='remove related patient' className={classes.remove_patient} click={() => setShowConfirm(true)} btnStyle={'btn_remove_small'} isLoading={removeLoading}>
                        <i className='ti ti-x'></i>
                    </Button>
                    {showConfirm && (
                        <RemoveDataConfirmationModal
                            closeModal={() => setShowConfirm(false)}
                            removeData={removePatientHandler}
                            message={'Are you sure you want to remove this related patient?'}
                            position={'right'}
                        />
                    )}
                </div>
            )}
        </div>
    </div>
}

export default RelatedPatientItem
